// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-header[data-v-06882745] {\n  position: fixed;\n  top: 80px;\n  width: 100%;\n  z-index: 100;\n  background-color: #fff;\n}\n@media (max-width: 991.98px) {\n.progress-header[data-v-06882745] {\n    top: 80px;\n}\n}\n.progress-disable[data-v-06882745] {\n  opacity: 0.5;\n}\n@media (min-width: 2160px) {\n.back-btn img[data-v-06882745] {\n    width: 37.5px;\n    height: 19.5px;\n}\n}", ""]);
// Exports
module.exports = exports;
